import ReactDOM from 'react-dom'
import React, { PureComponent } from 'react'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import getPreSignedURLForImageService from '../../Services/Queries/getPreSignedURLForImageService'
import ImageOptions from './ImageOptions'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { widthPercentageToDP, heightPercentageToDP } from '../../Utils/ResponsiveScreen'
import { Modal, Button } from 'react-bootstrap'
import CreateDynamicButton from './CreateDynamicButton'
import CreateMultiDynamicButtons from './CreateMultiDynamicButtons'
import CompressContentImage from '../../Services/Mutations/compressContentImage'

class FlipToStoryContent extends PureComponent {
	constructor(props) {
		super(props)
		this.state = {
			cropImage1: false,
			cropImage2: false,
			coverStoryCardCroppedImage: '',
			coverStoryCroppedImage: '',
			coverStoryTitle: '',
			coverStoryCardDescription: '',
			textColorOptions: [
				{ item: 'white', id: 1, value: '#ffffff' },
				{ item: 'black', id: 2, value: '#000000' },
				{ item: 'grey', id: 3, value: '#bdbdbd' },
			],
			selectedTextColorOption: '#ffffff',
			imageFor: '',
			coverStoryImages: [],
			coverStoryCardImages: [],
			titleOptionsVisibility: false,
			contentPosition: '50',
			displayTitleBackground: false,
			expandedImage: null,
			expanded: true,
			files: [],
			youtubeID: '',
			selectedtype: 'Image',
			urlType: 'Instagram',
			watchType: 'Off',
			instagramLink: '',
			youtubeLink: '',
			twitterLink: '',
			websiteLink: '',
			styleType: 'Custom',
			coverStoryVideoURL: '',
			storyVideoKey: '',
			deleteVideosFromS3: [],
			imageFor: '',
			src: null,
			//for full image
			crop: {
				unit: '%',
				width: 30,
				// width: widthPercentageToDP('100%'),
				// height: heightPercentageToDP('100%'),
				// aspect: widthPercentageToDP('100%') / heightPercentageToDP('100%'),
				aspect: 9 / 16,
			},
			src2: null,
			// for card image
			crop2: {
				unit: '%',
				width: 30,
				// width: widthPercentageToDP('100%'),
				// height: heightPercentageToDP('100%'),
				// aspect: widthPercentageToDP('100%') / heightPercentageToDP('40%'),
				aspect: 16 / 9,
			},
			imageSizeLimit: 900,
			contentNewLinkDetails: {},
			isVertical: false,
			imageSizeLimitModal1: false,
			imageSizeLimitModal2: false,
		}
	}

	handleTitle = (e) => {
		const title = e.target.value
		this.setState({ coverStoryTitle: title })
		this.props.updateChildElements(
			`coverStoryTitle_${this.props.contentSelectedLangVal}`,
			title,
			'FlipToStory'
		)
	}
	handleCardDescription = (e) => {
		const cardDescription = e.target.value
		this.setState({ coverStoryCardDescription: cardDescription })
		this.props.updateChildElements(
			`coverStoryCardDescription_${this.props.contentSelectedLangVal}`,
			cardDescription,
			'FlipToStory'
		)
	}
	handleStyleType = (style) => {
		this.setState({ styleType: style })
		this.props.updateChildElements('styleType', style, 'FlipToStory')
	}
	handleCoverStoryCardImages = (images) => {
		const imagesArr = []
		images.filter((item) => {
			const obj = {
				image: item.key ? item.key : item.image,
				copyRight: item.copyRight,
				copyRightText: item.copyRightText,
				shareImage: item.shareImage,
			}
			imagesArr.push(obj)
		})
		this.setState({
			coverStoryCardImages: images,
			expandedImage: images.length ? images[images.length - 1].key : '',
			expanded: true,
		})
		console.log(imagesArr, images, '112')
		this.props.updateChildElements('coverStoryCardImages', imagesArr, 'FlipToStory')
		this.props.updateChildElements('coverStoryCardOriginalImages', images, 'FlipToStory')
	}
	handleCoverStoryImages = (images) => {
		const imagesArr = []
		images.filter((item) => {
			const obj = {
				image: item.key ? item.key : item.image,
				copyRight: item.copyRight,
				copyRightText: item.copyRightText,
				shareImage: item.shareImage,
			}
			imagesArr.push(obj)
		})
		this.setState({
			coverStoryImages: images,
			expandedImage: images.length ? images[images.length - 1].key : '',
			expanded: true,
		})
		this.props.updateChildElements('coverStoryImages', imagesArr, 'FlipToStory')
		this.props.updateChildElements('coverStoryOriginalImages', images, 'FlipToStory')
	}

	hastitleError = () => {
		return !this.state.coverStoryTitle
	}
	hasCardDescriptionError = () => {
		return !this.state.coverStoryCardDescription
	}
	handleCoverStoryCardImagesError = () => {
		return !this.state.coverStoryCardImages.length
	}
	handleCoverStoryImagesError = () => {
		return !this.state.coverStoryImages.length
	}

	handleTextColorRadioButton = (item) => {
		this.setState({ selectedTextColorOption: item.value })
		this.props.updateChildElements('textColor', item.value, 'FlipToStory')
	}
	handleShowTitleBackground = () => {
		this.setState(
			{
				displayTitleBackground: !this.state.displayTitleBackground,
			},
			() => {
				this.props.updateChildElements(
					'backGroundTitle',
					this.state.displayTitleBackground,
					'FlipToStory'
				)
			}
		)
	}
	handleContentPosition = (e) => {
		const contentPosition = e.target.value
		this.setState({ contentPosition: contentPosition })
		this.props.updateChildElements('contentTitlePosition', contentPosition, 'FlipToStory')
	}
	GetDate = () => {
		return (
			new Date().getFullYear() +
			'' +
			('0' + (new Date().getMonth() + 1)).slice(-2) +
			('0' + new Date().getDate()).slice(-2)
		)
	}

	removeVideo = () => {
		const deleteVideosFromS3 = this.state.deleteVideosFromS3
		deleteVideosFromS3.push(this.state.storyVideoKey)
		this.setState({
			deleteVideosFromS3: deleteVideosFromS3,
			coverStoryVideoURL: '',
			storyVideoKey: '',
		})
		this.props.updateChildElements('coverStoryVideoURL', '', 'FlipToStory')
	}
	handleUploadVideo = (e) => {
		const files = e.target.files
		let file = files[0]
		let reader = new FileReader()
		let videoName = file.name
		const index = videoName.lastIndexOf('.')
		if (index == 0) {
			videoName = 'dummy' + '' + videoName.replace(/[&\/\\#@,+()$~%'":*?<>{}]/g, '')
		}
		let videosName = ''
		if (index != -1) {
			videosName = videoName.substring(0, index).replace(/[&\/\\#@.,+()$~%'":*?<>{}]/g, '')
			videosName = videosName.length > 0 ? videosName : 'dummy'
		}
		videoName = videosName.replaceAll(' ', '') + '.mp4'

		reader.onloadend = async () => {
			const contentID = this.props.contentID.includes('cont#')
				? this.props.contentID.split('cont#')[1]
				: this.props.contentID
			const key = 'public/' + this.GetDate() + '/contents/' + contentID + '/Input/' + videoName
			const params = {
				key: key,
				mimeType: file.type,
			}
			const preSignedURLObject = await getPreSignedURLForImageService(params)
			const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
			const signedURL = signedURLObject.data['url']
			try {
				const formData = new FormData()
				Object.keys(signedURLObject.data.fields).forEach((key) => {
					formData.append(key, signedURLObject.data.fields[key])
				})
				// Actual file has to be appended last.
				formData.append('file', file)

				const response = await axios({
					method: 'post',
					url: signedURL,
					data: formData,
					headers: { 'Content-Type': 'multipart/form-data' },
				})
				if (response.status) {
					this.setState({ coverStoryVideoURL: reader.result, storyVideoKey: key })
					this.props.updateVideodetails({ contentVideoKey: key })
					this.props.updateChildElements('coverStoryVideoURL', key, 'FlipToStory')
				}
			} catch (err) {
				console.warn(err, 'err')
			}
		}
		reader.readAsDataURL(file)
	}
	uploadImage = (imageFor, e) => {
		this.setState(
			{
				imageFor: imageFor,
			},
			() => {
				// const { files } = this.state
				// files.push(...e.target.files)
				const files = e.target.files
				e.preventDefault()

				for (let i = 0; i < files.length; i++) {
					let file = files[i]

					let reader = new FileReader()
					reader.onloadend = async () => {
						const randomId = await uuidv4()
						const key = 'public/' + this.GetDate() + '/contents/' + randomId
						const params = {
							key: key,
							mimeType: file.type,
						}
						const preSignedURLObject = await getPreSignedURLForImageService(params)
						const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
						const signedURL = signedURLObject.data['url']
						try {
							const formData = new FormData()
							Object.keys(signedURLObject.data.fields).forEach((key) => {
								formData.append(key, signedURLObject.data.fields[key])
							})
							// Actual file has to be appended last.
							formData.append('file', file)

							const response = await axios({
								method: 'post',
								url: signedURL,
								data: formData,
								headers: { 'Content-Type': 'multipart/form-data' },
							})
							if (response.status) {
								const imageObj = {
									key: key,
									imageValue: reader.result,
									copyRight: false,
									copyRightText: '',
									shareImage: false,
								}
								this.uploadImages(imageFor, imageObj)
							}
						} catch (err) {
							console.warn(err, 'err')
						}
					}
					reader.readAsDataURL(file)
				}
			}
		)
	}
	removeCoverStoryImage = (imageIndex) => {
		const images = this.state.coverStoryImages
		images.splice(imageIndex, 1)
		this.handleCoverStoryImages(images)
	}
	removeCoverStoryCardImage = (imageIndex) => {
		const images = this.state.coverStoryCardImages
		images.splice(imageIndex, 1)
		this.handleCoverStoryCardImages(images)
	}
	toggleCopyRightSwitch = (key, fullImage) => {
		const { coverStoryImages, coverStoryCardImages } = this.state
		if (fullImage) {
			const updatedCsImages = coverStoryImages.filter((item) => {
				if (item.key == key) {
					item.copyRight = !item.copyRight
				}
				return item
			})
			this.handleCoverStoryImages(updatedCsImages)
		} else {
			const updatedCsCardImages = coverStoryCardImages.filter((item) => {
				if (item.key == key) {
					item.copyRight = !item.copyRight
				}
				return item
			})
			this.handleCoverStoryCardImages(updatedCsCardImages)
		}
	}

	handleCopyrightText = (key, e, fullImage) => {
		const text = e.target.value
		const { coverStoryImages, coverStoryCardImages } = this.state
		if (fullImage) {
			const updatedCsImages = coverStoryImages.filter((item) => {
				if (item.key == key) {
					item.copyRightText = text
				}
				return item
			})
			this.handleCoverStoryImages(updatedCsImages)
		} else {
			const updatedcsCardImages = coverStoryCardImages.filter((item) => {
				if (item.key == key) {
					item.copyRightText = text
				}
				return item
			})
			this.handleCoverStoryCardImages(updatedcsCardImages)
		}
	}

	handleCopyrightType = (key, copyrightPrefix, fullImage) => {
		const { coverStoryImages, coverStoryCardImages } = this.state
		if (fullImage) {
			const updatedCsImages = coverStoryImages.filter((item) => {
				if (item.key == key) {
					item.copyRightText = copyrightPrefix
				}
				return item
			})
			this.handleCoverStoryImages(updatedCsImages)
		} else {
			const updatedCsCardImages = coverStoryCardImages.filter((item) => {
				if (item.key == key) {
					item.copyRightText = copyrightPrefix
				}
				return item
			})
			this.handleCoverStoryCardImages(updatedCsCardImages)
		}
	}

	toggleShareImageSwitch = (key, fullImage) => {
		const { coverStoryImages, coverStoryCardImages } = this.state
		if (fullImage) {
			coverStoryImages.filter((item) => {
				if (item.key == key) {
					item.shareImage = !item.shareImage
				}
			})
			this.handleCoverStoryImages(coverStoryImages)
		} else {
			coverStoryCardImages.filter((item) => {
				if (item.key == key) {
					item.shareImage = !item.shareImage
				}
			})
			this.handleCoverStoryCardImages(coverStoryCardImages)
		}
	}

	uploadImages = (imageFor, imageObj) => {
		const { coverStoryImages, coverStoryCardImages } = this.state
		if (imageFor == 'coverStoryImages') {
			coverStoryImages.push(imageObj)
			this.handleCoverStoryImages(coverStoryImages)
		} else {
			coverStoryCardImages.push(imageObj)
			this.handleCoverStoryCardImages(coverStoryCardImages)
		}
	}

	updatecontentLinkDetails = () => {
		const linkInput = {
			watchType: this.state.watchType,
			instagramLink: this.state.instagramLink,
			youtubeLink: this.state.youtubeLink,
			twitterLink: this.state.twitterLink,
			websiteLink: this.state.websiteLink,
		}

		if (this.state.watchType == 'watchVideo') {
			linkInput.urlType = this.state.urlType
		}
		if (this.state.watchType == 'visitWebsite') {
			linkInput.urlType = 'website'
		}

		this.props.updateChildElements('contentLinkDetails', linkInput, 'FlipToStory')
	}
	updatecontentNewLinkDetails = (linkInput) => {
		linkInput.map((buttonObj) => {
			if (buttonObj.category == 'socialMedia') {
				const input = {
					instagramLink: buttonObj.instagramLink,
					youtubeLink: buttonObj.youtubeLink,
					twitterLink: buttonObj.twitterLink,
					websiteLink: '',
					urlType: buttonObj.urlType?.replace('Link', ''),
					watchType: 'watchVideo',
				}
				this.props.updateChildElements('contentLinkDetails', input, 'FlipToStory')
			}
		})
		this.props.updateChildElements('contentNewLinkDetails', linkInput, 'FlipToStory')
	}

	handleWatchType = (value) => {
		if (this.state.watchType != value) {
			this.setState(
				{
					watchType: value,
					urlType: 'Instagram',
					instagramLink: '',
					youtubeLink: '',
					twitterLink: '',
					websiteLink: '',
				},
				() => {
					this.updatecontentLinkDetails()
				}
			)
		}
	}
	handleType = (selectedtype) => {
		this.setState({
			youtubeID: '',
			coverStoryVideoURL: '',
			coverStoryCardImages: [],
			selectedtype: selectedtype,
		})
		this.props.updateChildElements('youtubeID', '', 'FlipToStory')
		this.props.updateChildElements('coverStoryVideoURL', '', 'FlipToStory')
		this.props.updateChildElements('coverStoryCardImages', [], 'FlipToStory')
	}
	handleYoutubeID = async (e) => {
		const youtubeID = e.target.value
		let isVertical = this.state.isVertical
		console.log(youtubeID, 'youtubeID')
		try {
			const response = await axios.get(
				`https://www.googleapis.com/youtube/v3/videos?key=AIzaSyC5rCU5SQMZ6DI_Z2NguvCEX8bZ2cBIpUw&part=snippet,contentDetails,status,player,statistics&id=${youtubeID}`,
				{
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					// params: {
					//     lat: parseFloat(location.latitude).toFixed(4),
					//     lng: parseFloat(location.longitude).toFixed(4),
					//     username: 'ismail.shaik',
					//     cities: 'cities1000',
					// },
				}
			)
			console.log(response, 'response is')
			const iframe = response.data.items[0].player.embedHtml
			const width = iframe.split('width="')[1].split('" ')[0]
			const height = iframe.split('height="')[1].split('" ')[0]
			isVertical = height >= '360' ? true : false
			console.log(height, 'height video is')
			console.log(width, 'width video is')
			// console.log(isVertical, 'vertical video is')
			// setisVertical(height == '360' ? true : false)
		} catch (error) {
			console.log(error, 'error is')
		}

		const youtubeVideoOrientation = isVertical ? 'vertical' : 'horizontal'
		this.setState({ youtubeID: youtubeID, isVertical: isVertical })
		this.props.updateChildElements('youtubeID', youtubeID, 'FlipToStory')
		this.props.updateChildElements(
			'youtubeVideoOrientation',
			youtubeVideoOrientation,
			'FlipToStory'
		)
	}
	handleYoutubeVideoType = (vertical) => {
		this.setState({ isVertical: vertical })
		const youtubeVideoOrientation = vertical ? 'vertical' : 'horizontal'

		this.props.updateChildElements(
			'youtubeVideoOrientation',
			youtubeVideoOrientation,
			'FlipToStory'
		)
	}
	handleYoutubeIDError = () => {
		return !this.state.youtubeID != ''
	}
	handleUrlType = (value) => {
		this.setState({ urlType: value, instagramLink: '', youtubeLink: '', twitterLink: '' }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handleinstagramLink = (e) => {
		const link = e.target.value

		this.setState({ instagramLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handleinstagramLinkError = () => {
		return !this.state.instagramLink != ''
	}
	handleyoutubeLink = (e) => {
		const link = e.target.value

		this.setState({ youtubeLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handleyoutubeLinkError = () => {
		return !this.state.youtubeLink != ''
	}
	handletwitterLink = (e) => {
		const link = e.target.value

		this.setState({ twitterLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handletwitterLinkError = () => {
		return !this.state.twitterLink != ''
	}
	handlewebsiteLink = (e) => {
		const link = e.target.value
		this.setState({ websiteLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handlewebsiteLinkError = () => {
		return !this.state.websiteLink != ''
	}
	removeSelectedImage = (imageFor) => {
		if (imageFor == 'coverStoryImages') {
			this.setState({
				cropImage1: false,
				src: null,
				coverStoryImages: [],
				crop: {
					unit: '%',
					width: 30,
					aspect: 9 / 16,
				},
				croppedImageUrl: '',
				selectedCoverStoryImage: '',
			})
			this.props.updateChildElements('coverStoryImages', [], 'FlipToStory')
		} else {
			this.setState({
				cropImage2: false,
				src2: '',
				coverStoryCardImages: [],
				crop2: {
					unit: '%',
					width: 30,
					aspect: 16 / 9,
				},
				croppedImageUrl2: '',
				selectedCoverStoryCardImage: '',
			})
			this.props.updateChildElements('coverStoryCardImages', [], 'FlipToStory')
		}
	}
	uploadSelectedImage = async (imageFor, crop) => {
		const randomId = await uuidv4()
		const key = 'public/' + this.GetDate() + '/contents/' + randomId
		const params = {
			key: key,
			mimeType:
				imageFor == 'coverStoryImages'
					? this.state.selectedCoverStoryImage.type
					: this.state.selectedCoverStoryCardImage.type,
		}
		const preSignedURLObject = await getPreSignedURLForImageService(params)
		const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
		const signedURL = signedURLObject.data['url']
		try {
			const formData = new FormData()
			Object.keys(signedURLObject.data.fields).forEach((key) => {
				formData.append(key, signedURLObject.data.fields[key])
			})
			const croppedFile =
				this.state.imageFor == 'coverStoryImages'
					? this.state.coverStoryCroppedImage
					: this.state.coverStoryCardCroppedImage
			const originalFile =
				this.state.imageFor == 'coverStoryImages'
					? this.state.selectedCoverStoryImage
					: this.state.selectedCoverStoryCardImage
			// Actual file has to be appended last.
			if (crop) {
				formData.append('file', croppedFile)
			} else {
				formData.append('file', originalFile)
			}
			const response = await axios({
				method: 'post',
				url: signedURL,
				data: formData,
				headers: { 'Content-Type': 'multipart/form-data' },
			})
			let selectedImageValue = ''
			if (this.state.imageFor == 'coverStoryImages') {
				selectedImageValue = this.state.croppedImageUrl
					? this.state.croppedImageUrl
					: this.state.src
			} else {
				selectedImageValue = this.state.croppedImageUrl2
					? this.state.croppedImageUrl2
					: this.state.src2
			}

			if (response.status) {
				const imageObj = {
					imageValue: selectedImageValue,
					key: key,
					copyRight: false,
					copyRightText: '',
					shareImage: false,
				}
				const input = {
					imagePath: imageObj.key
				}
				console.log(input, "======compressImageinput")
				if (input != undefined && input != null && input.imagePath != null && input.imagePath != undefined && input.imagePath != "") {
					const response = await CompressContentImage(input)
					console.log(response, "response compress image ==========")
				}
				this.uploadImages(imageFor, imageObj)
			}
		} catch (err) {
			console.warn(err, 'err')
		}
	}
	// hideImageSizeLimitModal = () => {
	// 	this.setState({
	// 		imageSizeLimitModal: false,
	// 	})
	// }
	onSelectFile = (e) => {
		// const limitUpload = e?.target?.files[0]?.size / 1000 <= 900
		let pngImageExists = false
		pngImageExists = e?.target?.files[0]?.type?.includes('png')
		if (!pngImageExists) {
			this.setState({ imageFor: 'coverStoryImages' })
			if (e.target.files && e.target.files.length > 0) {
				const reader = new FileReader()
				reader.addEventListener('load', () => this.setState({ src: reader.result }))
				reader.readAsDataURL(e.target.files[0])
				this.setState({
					cropImage1: false,
					coverStoryImages: [],
					selectedCoverStoryImage: e.target.files[0],
					// crop: false,
					imageSizeLimitModal1: false,
					croppedImageUrl: '',
					coverStoryCroppedImage: '',
				})
			}
		} else {
			this.setState({
				imageSizeLimitModal1: true,
			})
		}
	}
	onSelectFile2 = (e) => {
		let pngImageExists = false
		pngImageExists = e?.target?.files[0]?.type?.includes('png')
		if (!pngImageExists) {
			this.setState({ imageFor: 'coverStoryCardImages' })
			if (e.target.files && e.target.files.length > 0) {
				const reader = new FileReader()
				reader.addEventListener('load', () => this.setState({ src2: reader.result }))
				reader.readAsDataURL(e.target.files[0])
				this.setState({
					cropImage2: false,
					imageSizeLimitModal2: false,
					coverStoryCardImages: [],
					selectedCoverStoryCardImage: e.target.files[0],
					// crop2: false,
					croppedImageUrl2: '',
					coverStoryCardCroppedImage: '',
				})
			}
		} else {
			this.setState({
				imageSizeLimitModal2: true,
			})
		}
	}

	// If you setState the crop in here you should return false.
	onImageLoaded = (image) => {
		this.imageRef = image
	}

	onCropComplete = (crop) => {
		this.makeClientCrop(crop)
	}

	onCropChange = (crop, percentCrop) => {
		// You could also use percentCrop:
		// this.setState({ crop: percentCrop });
		this.setState({ crop })
	}
	onImageLoaded2 = (image) => {
		this.imageRef2 = image
	}

	onCropComplete2 = (crop) => {
		this.makeClientCrop2(crop)
	}

	onCropChange2 = (crop, percentCrop) => {
		// You could also use percentCrop:
		// this.setState({ crop: percentCrop });
		this.setState({ crop2: crop })
	}

	async makeClientCrop(crop) {
		if (this.imageRef && crop.width && crop.height) {
			const croppedImageUrl = await this.getCroppedImg(this.imageRef, crop, 'newFile.jpeg')
			this.setState({ croppedImageUrl })
		}
	}
	async makeClientCrop2(crop) {
		if (this.imageRef2 && crop.width && crop.height) {
			const croppedImageUrl = await this.getCroppedImg(this.imageRef2, crop, 'newFile.jpeg')
			this.setState({ croppedImageUrl2: croppedImageUrl })
		}
	}

	getCroppedImg(image, crop, fileName) {
		const canvas = document.createElement('canvas')
		const pixelRatio = window.devicePixelRatio
		const scaleX = image.naturalWidth / image.width
		const scaleY = image.naturalHeight / image.height
		const ctx = canvas.getContext('2d')

		canvas.width = crop.width * pixelRatio * scaleX
		canvas.height = crop.height * pixelRatio * scaleY

		ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
		ctx.imageSmoothingQuality = 'high'

		ctx.drawImage(
			image,
			crop.x * scaleX,
			crop.y * scaleY,
			crop.width * scaleX,
			crop.height * scaleY,
			0,
			0,
			crop.width * scaleX,
			crop.height * scaleY
		)

		return new Promise((resolve, reject) => {
			canvas.toBlob(
				(blob) => {
					if (!blob) {
						//reject(new Error('Canvas is empty'));
						console.error('Canvas is empty')
						return
					}
					blob.name = fileName
					window.URL.revokeObjectURL(this.fileUrl)
					this.fileUrl = window.URL.createObjectURL(blob)
					if (this.state.imageFor == 'coverStoryImages') {
						this.setState({ coverStoryCroppedImage: blob })
					} else {
						this.setState({ coverStoryCardCroppedImage: blob })
					}
					resolve(this.fileUrl)
				},
				'image/jpeg',
				1
			)
		})
	}
	componentDidMount() {
		const { editContent, contentSelectedLangVal } = this.props
		const { flipToStoryDetails } = this.props
		if (editContent) {
			const youtubeID = this.props.flipToStoryDetails.youtubeID
			const images = this.props.flipToStoryDetails.coverStoryImages
				? this.props.flipToStoryDetails.coverStoryImages
				: []
			const videourl = this.props.flipToStoryDetails.coverStoryVideoURL
			const selectedtype =
				images.length > 0
					? 'Image'
					: videourl != ''
						? 'Video'
						: youtubeID != ''
							? 'youtubeID'
							: 'Image'
			this.setState({
				selectedtype: selectedtype,
				coverStoryVideoURL: flipToStoryDetails.coverStoryVideoURL
					? flipToStoryDetails.coverStoryVideoURL
					: '',
				youtubeID: flipToStoryDetails.youtubeID ? flipToStoryDetails.youtubeID : '',
				coverStoryTitle: flipToStoryDetails[`coverStoryTitle_${contentSelectedLangVal}`],
				coverStoryCardDescription:
					flipToStoryDetails[`coverStoryCardDescription_${contentSelectedLangVal}`],
				selectedTextColorOption: flipToStoryDetails.textColor
					? flipToStoryDetails.textColor
					: '#fffff',
				contentTitlePosition: flipToStoryDetails.contentTitlePosition
					? flipToStoryDetails.contentTitlePosition
					: 50,
				displayTitleBackground: flipToStoryDetails.backGroundTitle
					? flipToStoryDetails.backGroundTitle
					: false,
				styleType: flipToStoryDetails.styleType ? flipToStoryDetails.styleType : 'Custom',
				src:
					flipToStoryDetails.coverStoryImages && flipToStoryDetails.coverStoryImages[0]
						? flipToStoryDetails.coverStoryImages[0].image
						: '',
				src2:
					flipToStoryDetails.coverStoryCardImages && flipToStoryDetails.coverStoryCardImages[0]
						? flipToStoryDetails.coverStoryCardImages[0].image
						: '',
				coverStoryImages: flipToStoryDetails.coverStoryImages
					? flipToStoryDetails.coverStoryImages
					: [],
				coverStoryCardImages: flipToStoryDetails.coverStoryCardImages
					? flipToStoryDetails.coverStoryCardImages
					: [],
				watchType: flipToStoryDetails.contentLinkDetails
					? flipToStoryDetails.contentLinkDetails.watchType
					: 'Off',
				urlType: flipToStoryDetails.contentLinkDetails
					? flipToStoryDetails.contentLinkDetails.urlType
					: 'Instagram',
				instagramLink: flipToStoryDetails.contentLinkDetails
					? flipToStoryDetails.contentLinkDetails.instagramLink
					: '',
				youtubeLink: flipToStoryDetails.contentLinkDetails
					? flipToStoryDetails.contentLinkDetails.youtubeLink
					: '',
				twitterLink: flipToStoryDetails.contentLinkDetails
					? flipToStoryDetails.contentLinkDetails.twitterLink
					: '',
				websiteLink: flipToStoryDetails.contentLinkDetails
					? flipToStoryDetails.contentLinkDetails.websiteLink
					: '',
				contentNewLinkDetails: flipToStoryDetails.contentNewLinkDetails
					? flipToStoryDetails.contentNewLinkDetails
					: {},
				isVertical:
					flipToStoryDetails.youtubeVideoOrientation &&
						flipToStoryDetails.youtubeVideoOrientation == 'vertical'
						? true
						: false,
			})
		}
	}
	componentDidUpdate = (prevProps) => {
		if (prevProps.contentSelectedLangVal != this.props.contentSelectedLangVal) {
			const { editContent, contentSelectedLangVal } = this.props
			const { flipToStoryDetails } = this.props
			if (editContent) {
				const youtubeID = this.props.flipToStoryDetails.youtubeID
				const images = this.props.flipToStoryDetails.coverStoryImages
					? this.props.flipToStoryDetails.coverStoryImages
					: []
				const videourl = this.props.flipToStoryDetails.coverStoryVideoURL
				const selectedtype =
					images.length > 0
						? 'Image'
						: videourl != ''
							? 'Video'
							: youtubeID != ''
								? 'youtubeID'
								: 'Image'
				this.setState({
					selectedtype: selectedtype,
					coverStoryVideoURL: flipToStoryDetails.coverStoryVideoURL
						? flipToStoryDetails.coverStoryVideoURL
						: '',
					youtubeID: flipToStoryDetails.youtubeID ? flipToStoryDetails.youtubeID : '',
					coverStoryTitle: flipToStoryDetails[`coverStoryTitle_${contentSelectedLangVal}`],
					coverStoryCardDescription:
						flipToStoryDetails[`coverStoryCardDescription_${contentSelectedLangVal}`],
					selectedTextColorOption: flipToStoryDetails.textColor
						? flipToStoryDetails.textColor
						: '#fffff',
					contentTitlePosition: flipToStoryDetails.contentTitlePosition
						? flipToStoryDetails.contentTitlePosition
						: 50,
					displayTitleBackground: flipToStoryDetails.backGroundTitle
						? flipToStoryDetails.backGroundTitle
						: false,
					styleType: flipToStoryDetails.styleType ? flipToStoryDetails.styleType : 'Custom',
					src: flipToStoryDetails.coverStoryImages
						? flipToStoryDetails.coverStoryImages[0].image
						: '',
					src2: flipToStoryDetails.coverStoryCardImages
						? flipToStoryDetails.coverStoryCardImages[0].image
						: '',
					coverStoryImages: flipToStoryDetails.coverStoryImages
						? flipToStoryDetails.coverStoryImages
						: [],
					coverStoryCardImages: flipToStoryDetails.coverStoryCardImages
						? flipToStoryDetails.coverStoryCardImages
						: [],
					watchType: flipToStoryDetails.contentLinkDetails
						? flipToStoryDetails.contentLinkDetails.watchType
						: 'Off',
					urlType: flipToStoryDetails.contentLinkDetails
						? flipToStoryDetails.contentLinkDetails.urlType
						: 'Instagram',
					instagramLink: flipToStoryDetails.contentLinkDetails
						? flipToStoryDetails.contentLinkDetails.instagramLink
						: '',
					youtubeLink: flipToStoryDetails.contentLinkDetails
						? flipToStoryDetails.contentLinkDetails.youtubeLink
						: '',
					twitterLink: flipToStoryDetails.contentLinkDetails
						? flipToStoryDetails.contentLinkDetails.twitterLink
						: '',
					websiteLink: flipToStoryDetails.contentLinkDetails
						? flipToStoryDetails.contentLinkDetails.websiteLink
						: '',
					contentNewLinkDetails: flipToStoryDetails.contentNewLinkDetails
						? flipToStoryDetails.contentNewLinkDetails
						: {},
				})
			}
		}
	}
	renderContentLinkDetails = () => {
		const { urlType, watchType, youtubeLink, instagramLink, twitterLink, websiteLink } = this.state

		return (
			<div>
				<div style={{ marginRight: 10 }}>
					<input
						value={watchType}
						type='radio'
						checked={watchType == 'Off'}
						onChange={() => {
							this.handleWatchType('Off')
						}}
					></input>
					<text for={'Off'}>{'Off'}</text>
				</div>
				<div style={{ marginRight: 10 }}>
					<input
						value={watchType}
						type='radio'
						checked={watchType == 'watchVideo'}
						onChange={() => {
							this.handleWatchType('watchVideo')
						}}
					></input>
					<text for={'watchVideo'}>{'Watch Video'}</text>
				</div>
				<div style={{ marginRight: 10 }}>
					<input
						value={watchType}
						type='radio'
						checked={watchType == 'visitWebsite'}
						onChange={() => {
							this.handleWatchType('visitWebsite')
						}}
					></input>
					<text for={'visitWebsite'}>{'Visit Website'}</text>
				</div>
				{watchType == 'watchVideo' ? (
					<div>
						<text>{'Watch On : '}</text>
						<div>
							<input
								value={urlType}
								type='radio'
								checked={urlType == 'Instagram'}
								onChange={() => {
									this.handleUrlType('Instagram')
								}}
							></input>
							<text>{'Instagram'}</text>
						</div>
						<div>
							<input
								value={urlType}
								type='radio'
								checked={urlType == 'Youtube'}
								onChange={() => {
									this.handleUrlType('Youtube')
								}}
							></input>
							<text>{'Youtube'}</text>
						</div>
						<div>
							<input
								value={urlType}
								type='radio'
								checked={urlType == 'Twitter'}
								onChange={() => {
									this.handleUrlType('Twitter')
								}}
							></input>
							<text>{'Twitter'}</text>
						</div>
					</div>
				) : null}
				{watchType == 'watchVideo' && urlType == 'Instagram' ? (
					<div>
						<text for='text'>Instagram Link :</text>
						<textarea
							type='text'
							onChange={(value) => {
								this.handleinstagramLink(value)
							}}
							value={instagramLink}
							placeholder='Please Enter Instagram Link'
						></textarea>
						{this.handleinstagramLinkError() ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Instagram Link Cannot Be Empty
							</text>
						) : null}
					</div>
				) : null}
				{watchType == 'watchVideo' && urlType == 'Youtube' ? (
					<div>
						<text for='text'>Youtube Link :</text>
						<input
							type='text'
							onChange={(value) => {
								this.handleyoutubeLink(value)
							}}
							value={youtubeLink}
							placeholder='Please Enter Youtube Link'
						></input>
						{this.handleyoutubeLinkError() ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Youtube Link Cannot Be Empty
							</text>
						) : null}
					</div>
				) : null}
				{watchType == 'watchVideo' && urlType == 'Twitter' ? (
					<div>
						<text for='text'>Twitter Link :</text>
						<textarea
							type='text'
							onChange={(value) => {
								this.handletwitterLink(value)
							}}
							value={twitterLink}
							placeholder='Please Enter Twitter Link'
						></textarea>
						{this.handletwitterLinkError() ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Twitter Link Cannot Be Empty
							</text>
						) : null}
					</div>
				) : null}
				{watchType == 'visitWebsite' ? (
					<div>
						<text for='text'>Website Link :</text>
						<textarea
							type='text'
							onChange={(value) => {
								this.handlewebsiteLink(value)
							}}
							value={websiteLink}
							placeholder='Please Enter Website Link'
						></textarea>
						{this.handlewebsiteLinkError() ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Website Link Cannot Be Empty
							</text>
						) : null}
					</div>
				) : null}
			</div>
		)
	}
	renderTitleOptions = () => {
		const { textColorOptions, selectedTextColorOption, contentPosition } = this.state
		return (
			<details>
				<summary>Title Options</summary>
				<div class='justify-content-center' style={{ display: 'flex' }}>
					{textColorOptions.map((item, index) => (
						<div key={index}>
							{selectedTextColorOption == item.value ? (
								<div
									style={{
										backgroundColor: item.value,
										height: 50,
										width: 50,
										marginRight: 5,
										borderColor: 'red',
										borderStyle: 'solid',
									}}
									onClick={() => this.handleTextColorRadioButton(item)}
								></div>
							) : (
								<div
									style={{
										backgroundColor: item.value,
										height: 50,
										width: 50,
										marginRight: 5,
									}}
									onClick={() => this.handleTextColorRadioButton(item)}
								></div>
							)}
						</div>
					))}
				</div>
				<div class='col-md-12'>
					<input
						type='checkbox'
						onChange={this.handleShowTitleBackground}
						checked={this.state.displayTitleBackground}
					></input>
					<text for='text'> Show Title Background </text>
				</div>
				<div>
					<text for='text'>Content position from top (%) </text>
					<input
						type='number'
						onChange={(value) => {
							this.handleContentPosition(value)
						}}
						value={contentPosition}
						placeholder='Please Enter Title Position'
					></input>
				</div>
			</details>
		)
	}
	renderUploadType = () => {
		const { selectedtype } = this.state
		return (
			<div>
				<div style={{ marginRight: 10 }}>
					<input
						value={selectedtype}
						type='radio'
						checked={selectedtype == 'Image'}
						onChange={() => {
							this.handleType('Image')
						}}
					></input>
					<text for={'Image'}>{'Image'}</text>
				</div>
				<div style={{ marginRight: 10 }}>
					<input
						value={selectedtype}
						type='radio'
						checked={selectedtype == 'Video'}
						onChange={() => {
							this.handleType('Video')
						}}
					></input>
					<text for={'Video'}>{'Video'}</text>
				</div>
				<div style={{ marginRight: 10 }}>
					<input
						value={selectedtype}
						type='radio'
						checked={selectedtype == 'youtubeID'}
						onChange={() => {
							this.handleType('youtubeID')
						}}
					></input>
					<text for={'youtubeID'}>{'youtubeID'}</text>
				</div>
			</div>
		)
	}
	render() {
		const {
			coverStoryTitle,
			coverStoryCardDescription,
			coverStoryImages,
			coverStoryCardImages,
			selectedtype,
			youtubeID,
			coverStoryVideoURL,
			styleType,
			//coverstory images state
			src,
			crop,
			croppedImageUrl,
			cropImage1,

			// cardimages states
			src2,
			crop2,
			croppedImageUrl2,
			cropImage2,
			isVertical,
		} = this.state

		return (
			<div className='App'>
				<details>
					<summary>FlipToStory Details</summary>
					<div>
						<text for='text'>Title : </text>
						<textarea
							type='text'
							onChange={(value) => {
								this.handleTitle(value)
							}}
							value={coverStoryTitle}
							placeholder='Please Enter  Title'
						></textarea>
						{!coverStoryTitle ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Title Cannot Be Empty
							</text>
						) : null}
					</div>
					<div>
						<text for='text'>Card Description : </text>
						<textarea
							type='text'
							onChange={(value) => {
								this.handleCardDescription(value)
							}}
							value={coverStoryCardDescription}
							placeholder='Please Enter Description'
						></textarea>
						{!coverStoryCardDescription ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Description Cannot Be Empty
							</text>
						) : null}
					</div>
					<text for='text'>Style Type : </text>
					<div style={{ marginRight: 10 }}>
						<input
							value={styleType}
							type='radio'
							checked={styleType == 'Custom'}
							onChange={() => {
								this.handleStyleType('Custom')
							}}
						></input>
						<text for={'Custom'}>{'Custom'}</text>
					</div>

					<div>
						<input
							value={styleType}
							type='radio'
							checked={styleType == 'OverLay'}
							onChange={() => {
								this.handleStyleType('OverLay')
							}}
						></input>
						<text for={'OverLay'}>{'OverLay'}</text>
					</div>
					{styleType == 'Custom' ? this.renderTitleOptions() : null}
					{/* {this.renderContentLinkDetails()} */}
					<CreateMultiDynamicButtons
						editContent={this.props.editContent}
						contentNewLinkDetails={this.state.contentNewLinkDetails}
						updatecontentNewLinkDetails={this.updatecontentNewLinkDetails}
					/>

					{this.renderUploadType()}
					<div>
						<text for='text'>CoverStory Images :</text>
						<p for='text' style={{ color: 'red', fontSize: 10 }}>
							(Only JPG and JPEG images are allowed)
						</p>
						<div>
							<input type='file' accept=".jpg,.jpeg"
								onChange={this.onSelectFile} />
						</div>

						{cropImage1 && src && !coverStoryImages.length && (
							<ReactCrop
								src={src}
								crop={crop}
								ruleOfThirds
								onImageLoaded={this.onImageLoaded}
								onComplete={this.onCropComplete}
								onChange={this.onCropChange}
							/>
						)}
						{!cropImage1 ? <img style={{ maxWidth: '100%' }} src={src} /> : null}
						{!coverStoryImages.length && src && !cropImage1 && (
							<button onClick={() => this.uploadSelectedImage('coverStoryImages', false)}>
								Upload Image
							</button>
						)}
						{!coverStoryImages.length && src && !cropImage1 && (
							<button onClick={() => this.setState({ cropImage1: true })}>Crop Image</button>
						)}
						{croppedImageUrl && <img style={{ maxWidth: '100%' }} src={croppedImageUrl} />}
						{src ? (
							<button onClick={() => this.removeSelectedImage('coverStoryImages')}>
								Remove Image
							</button>
						) : null}

						{!coverStoryImages.length && croppedImageUrl ? (
							<button onClick={() => this.uploadSelectedImage('coverStoryImages', true)}>
								Upload Cropped Image
							</button>
						) : null}
						{!coverStoryImages.length ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Please Upload Image
							</text>
						) : null}
						<label for='text' style={{ color: 'red', fontSize: 10 }}>
							{this.state.imageSizeLimitModal1 ? "Only JPG,JPEG Images are allowed" : ""}
						</label>
						<div className='imagesContainer'>
							{coverStoryImages.map((item, index) => {
								const { copyRightText, copyRight, shareImage, key } = item
								const fullImage = true
								return (
									<div key={index} className='imgPreview'>
										{/* <img src={item.imageValue} />
                        <button onClick={() => this.removeCoverStoryImage(index)}>Remove</button> */}
										<ImageOptions
											item={item}
											copyRight={copyRight}
											copyRightText={copyRightText}
											toggleCopyRightSwitch={(key) => this.toggleCopyRightSwitch(key, fullImage)}
											handleCopyrightText={(key, text) =>
												this.handleCopyrightText(key, text, fullImage)
											}
											handleCopyrightType={(key, copyrightPrefix) =>
												this.handleCopyrightType(key, copyrightPrefix, fullImage)
											}
											shareImage={shareImage}
											toggleShareImageSwitch={(key) => this.toggleShareImageSwitch(key, fullImage)}
										/>
									</div>
								)
							})}
						</div>
					</div>

					{selectedtype == 'Image' ? (
						<div>
							<text for='text'>CoverStory Card Images :</text>
							<p for='text' style={{ color: 'red', fontSize: 10 }}>
								(Only JPG and JPEG images are allowed)								</p>
							<div>
								<input type='file' accept=".jpg,.jpeg" onChange={this.onSelectFile2} />
							</div>

							{cropImage2 && src2 && !coverStoryCardImages.length && (
								<ReactCrop
									src={src2}
									crop={crop2}
									ruleOfThirds
									onImageLoaded={this.onImageLoaded2}
									onComplete={this.onCropComplete2}
									onChange={this.onCropChange2}
								/>
							)}
							{!cropImage2 ? <img style={{ maxWidth: '100%' }} src={src2} /> : null}
							{!coverStoryCardImages.length && src2 && !cropImage2 && (
								<button onClick={() => this.uploadSelectedImage('coverStoryCardImages', false)}>
									Upload Image
								</button>
							)}
							{!coverStoryCardImages.length && src2 && !cropImage2 && (
								<button onClick={() => this.setState({ cropImage2: true })}>Crop Image</button>
							)}
							{croppedImageUrl2 && <img style={{ maxWidth: '100%' }} src={croppedImageUrl2} />}
							{src2 ? (
								<button onClick={() => this.removeSelectedImage('coverStoryCardImages')}>
									Remove Image
								</button>
							) : null}

							{!coverStoryCardImages.length && croppedImageUrl2 ? (
								<button onClick={() => this.uploadSelectedImage('coverStoryCardImages', true)}>
									Upload Cropped Image
								</button>
							) : null}
							{!coverStoryCardImages.length ? (
								<text for='text' style={{ color: 'red', fontSize: 10 }}>
									Please Upload Image
								</text>
							) : null}
							<label for='text' style={{ color: 'red', fontSize: 10 }}>
								{this.state.imageSizeLimitModal2 ? "Only JPG,JPEG Images are allowed" : ""}
							</label>
							<div className='imagesContainer'>
								{coverStoryCardImages.map((item, index) => {
									const { copyRightText, copyRight, shareImage, key } = item
									const fullImage = false
									return (
										<div key={index} className='imgPreview'>
											{/* <img src={item.imageValue} />
                        <button onClick={() => this.removeCoverStoryImage(index)}>Remove</button> */}
											<ImageOptions
												item={item}
												copyRight={copyRight}
												copyRightText={copyRightText}
												toggleCopyRightSwitch={(key) => this.toggleCopyRightSwitch(key, fullImage)}
												handleCopyrightText={(key, text) =>
													this.handleCopyrightText(key, text, fullImage)
												}
												handleCopyrightType={(key, copyrightPrefix) =>
													this.handleCopyrightType(key, copyrightPrefix, fullImage)
												}
												shareImage={shareImage}
												toggleShareImageSwitch={(key) =>
													this.toggleShareImageSwitch(key, fullImage)
												}
											/>
										</div>
									)
								})}
							</div>
						</div>
					) : null}
					{selectedtype == 'Video' ? (
						<div>
							<div class='row'>
								<text for='text'>Upload Video :</text>

								<input
									className='fileInput'
									type='file'
									accept='video/mp4'
									onChange={(e) => this.handleUploadVideo(e)}
								/>
								{!coverStoryVideoURL ? (
									<text for='text' style={{ color: 'red', fontSize: 10 }}>
										Please Upload Video
									</text>
								) : null}
							</div>
						</div>
					) : null}
					{coverStoryVideoURL ? (
						<div>
							<video width='320' height='240' controls>
								<source src={coverStoryVideoURL} type='video/mp4' />
							</video>
							<button onClick={() => this.removeVideo()}>Remove</button>
						</div>
					) : null}
					{selectedtype == 'youtubeID' ? (
						<div>
							<text for='text'>Youtube ID :</text>
							<textarea
								type='text'
								onChange={(value) => {
									this.handleYoutubeID(value)
								}}
								value={youtubeID}
								placeholder='Please Enter Youtube ID'
							></textarea>
							{this.handleYoutubeIDError() ? (
								<text for='text' style={{ color: 'red', fontSize: 10 }}>
									Youtube ID Cannot Be Empty
								</text>
							) : null}
						</div>
					) : null}
					{selectedtype == 'youtubeID' && youtubeID != '' ? (
						<div>
							<div style={{ marginRight: 10 }}>
								<input
									value={isVertical}
									type='radio'
									checked={isVertical}
									onChange={() => {
										this.handleYoutubeVideoType(true)
									}}
								></input>
								<text for={'Vertical'}>{'Vertical'}</text>
							</div>
							<div style={{ marginRight: 10 }}>
								<input
									value={!isVertical}
									type='radio'
									checked={!isVertical}
									onChange={() => {
										this.handleYoutubeVideoType(false)
									}}
								></input>
								<text for={'Horizontal'}>{'Horizontal'}</text>
							</div>
						</div>
					) : null}
				</details>

				{/* <Modal show={this.state.imageSizeLimitModal} onHide={() => this.hideImageSizeLimitModal()}>
					<Modal.Body>
						<div className='row'>
							<text>Maximum allowed Image size is {this.state.imageSizeLimit} Kb</text>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={() => this.hideImageSizeLimitModal()}>Ok</Button>
					</Modal.Footer>
				</Modal> */}
			</div>
		)
	}
}

export default FlipToStoryContent
